import { defineComponent, ref, onMounted } from 'vue'
import { Row as VanRow, Col as VanCol, Button as VanButton, Swipe as VanSwipe, SwipeItem as VanSwipeItem } from 'vant'
import { getApiV1ExternalLinksList } from '@/api/sdk.gen'
import type { ExternalLink } from '@/api/types.gen'
import { FakeKeywordsBox } from '@/components/lottery-tabs'
import { openExternal } from '@/utils/open-external'
import { ExternalAnchor } from '@/components/external-anchor'

const PLATFORM_LIST = [
  { lotteryType: 2, lotteryName: '澳彩' },
  { lotteryType: 1, lotteryName: '港彩' },
]

const LABEL_MAP: Record<number, string> = { 1: '港彩', 2: '澳彩' }

function fillCount(len: number): number {
  return (3 - (len % 3)) % 3
}

export interface BannerItem {
  id: string
  imageUrl: string
  linkUrl?: string
}

export const GalleryExternalLinks = defineComponent({
  props: {
    banners: { type: Array as () => BannerItem[], default: () => [] },
  },
  setup(props) {
    const lotteryType = ref(2)
    const links = ref<ExternalLink[]>([])
    const showCount = ref(12)

    onMounted(async () => {
      const res = await getApiV1ExternalLinksList({ query: { page: 1, size: 999, status: 1 } })
      links.value = res.data?.data?.list ?? []
    })

    /** 「查看更多 / 收起」：还有没展示的给「查看更多」，已全部展开且超过 12 个给「收起」 */
    function renderToggleButton(hasMore: boolean, total: number) {
      if (hasMore) {
        return (
          <VanButton
            class="btns"
            block
            plain
            hairline
            size="mini"
            onClick={() => (showCount.value += 12)}
          >
            点击查看更多网址
          </VanButton>
        )
      }
      if (total > 12) {
        return (
          <VanButton class="btns" block plain hairline size="mini" onClick={() => (showCount.value = 12)}>
            收起
          </VanButton>
        )
      }
      return null
    }

    return () => {
      const label = LABEL_MAP[lotteryType.value] ?? '港彩'
      const filtered = links.value
        .filter((l) => l.lottery_type === label)
        .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0))

      const displayed = filtered.slice(0, showCount.value)
      const fills = fillCount(displayed.length)
      const hasMore = filtered.length > showCount.value

      return (
        <div class="vant-swiper-body-mini">
          {/* 轮播图 */}
          {props.banners.length > 0 && (
            <VanSwipe autoplay={5000} indicatorColor="white" autoHeight>
              {props.banners.map((item) => (
                <VanSwipeItem key={item.id}>
                  <ExternalAnchor url={item.linkUrl ?? ''}>
                    <img src={item.imageUrl} alt="" />
                  </ExternalAnchor>
                </VanSwipeItem>
              ))}
            </VanSwipe>
          )}

          {/* 网址大全 */}
          <div class="mini-site">
            <div class="mtitle">网址大全：</div>

            <ul class="nav">
              {PLATFORM_LIST.map((p) => (
                <li key={p.lotteryType}>
                  <button
                    type="button"
                    class={['item-body btn-block', { act: p.lotteryType === lotteryType.value }]}
                    onClick={() => {
                      lotteryType.value = p.lotteryType
                      showCount.value = 12
                    }}
                  >
                    <span class="title block">
                      <b>{p.lotteryName}</b>
                    </span>
                  </button>
                </li>
              ))}
            </ul>

            <VanRow class="m-tuzhi-list">
              {displayed.map((item, idx) => (
                <VanCol key={item.id ?? idx} class="bg" onClick={() => item.link_url && openExternal(item.link_url)}>
                  <p>{item.link_title}</p>
                </VanCol>
              ))}
              {Array.from({ length: fills }).map((_, i) => (
                <VanCol key={`fill-${i}`} class="fillarr-style">
                  <div />
                </VanCol>
              ))}
            </VanRow>

            <div class="open-hides">
              <div class="paglist" style={{ display: 'flex', justifyContent: 'center' }}>
                {renderToggleButton(hasMore, filtered.length)}
              </div>
            </div>
          </div>
          <FakeKeywordsBox type={2} />
        </div>
      )
    }
  },
})

export default GalleryExternalLinks
